import React from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import {
  levelOptions,
  typeCostOptions,
} from "../../../../services/accMasn-services";
import { useTranslation } from "react-i18next";
import { Checkbox, FormControlLabel, FormGroup } from "@material-ui/core";
import {
  useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
  , useStylesUiElemment,
  useStylesSpDial, useStylesAutoBlack,
} from '../../../../St/Reports/UseStyle';
export default function AccountsSystemForm(props) {
  const { rptParams, onChangeData, AutoOptions, onChangeAutoData } = props;
  const { t } = useTranslation(["forms"]);
  const claslbl = useStylesLbl();
  const clasTF = useStylesTF();

  return (
    <React.Fragment>
      <Grid container style={{ padding: 5 }} spacing={1}>
        <Grid item lg={2} md={2} sm={2} xs={6}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            id="datef"
            label={t("date-from")}
            className={clasTF.rootCust}
            InputProps={{ className: claslbl.clrBlackTxt }}
            InputLabelProps={{ className: claslbl.clrBlackLblS }}
            type="date"
            format="YYYY-MM-DD"
            name="datef"
            value={rptParams.dateFrom}
            onChange={onChangeData("dateFrom")}
          />
        </Grid>

        <Grid item lg={2} md={2} sm={2} xs={6}>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            id="dateT"
            label={t("date-to")}
            className={clasTF.rootCust}
            InputProps={{ className: claslbl.clrBlackTxt }}
            InputLabelProps={{ className: claslbl.clrBlackLblS }}
            type="date"
            format="YYYY-MM-DD"
            name="datet"
            value={rptParams.dateTo}
            onChange={onChangeData("dateTo")}
          />
        </Grid>

        <Grid item lg={2} md={2} sm={2} xs={6}>
          <Autocomplete
            classes={clasTF}
            InputProps={{ className: claslbl.clrBlackTxt }}
            value={rptParams.center}
            onChange={(event, newValue) => {
              onChangeAutoData("center", newValue);
            }}
            id="combo-box-demo"
            size="small"
            options={AutoOptions.center}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            style={{}}
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                //InputLabelProps={{ shrink: true }}
                label={t("center")}
                variant="outlined"
                InputLabelProps={{ className: claslbl.clrBlackLblS }}

              />
            )}
          />
        </Grid>

        <Grid item lg={2} md={2} sm={2} xs={6}>
          <Autocomplete
            classes={clasTF}
            InputProps={{ className: claslbl.clrBlackTxt }}
            value={rptParams.branch}
            onChange={(event, newValue) => {
              onChangeAutoData("branch", newValue);
            }}
            id="combo-box-demo"
            size="small"
            options={AutoOptions.Branches}
            //getOptionLabel={(option) => option.name}
            getOptionLabel={(option) =>
              typeof option === "string" ? option : option.name
            }
            style={{}}
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                //InputLabelProps={{ shrink: true }}
                label={t("branch")}
                variant="outlined"
                InputLabelProps={{ className: claslbl.clrBlackLblS }}

              />
            )}
          />
        </Grid>
        <Grid item lg={1} md={1} sm={2} xs={6}>
          <Autocomplete
            classes={clasTF}
            InputProps={{ className: claslbl.clrBlackTxt }}
            value={rptParams.level}
            onChange={(event, newValue) => {
              onChangeAutoData("level", newValue);
            }}
            id="combo-box-demo6"
            size="small"
            options={levelOptions}
            getOptionLabel={(option) => option.label}
            style={{}}
            disableClearable
            renderInput={(params) => (
              <TextField
                {...params}
                // InputLabelProps={{ shrink: true }}
                label={t("level")}
                variant="outlined"
                InputLabelProps={{ className: claslbl.clrBlackLblS }}
              />
            )}
          />
        </Grid>
        {rptParams.type.finalAcc != -1 && (
          <Grid item lg={2} md={2} sm={2} xs={6}>
            <Autocomplete
              classes={clasTF}
              InputProps={{ className: claslbl.clrBlackTxt }}
              value={rptParams.type_cost}
              onChange={(event, newValue) => {
                onChangeAutoData("type_cost", newValue);
              }}
              id="combo-box-demo"
              size="small"
              options={typeCostOptions}
              getOptionLabel={(option) =>
                typeof option === "string" ? option : option.name
              }
              style={{}}
              disableClearable
              renderInput={(params) => (
                <TextField
                  {...params}
                  //InputLabelProps={{ shrink: true }}
                  label={"طريقة التقييم "}
                  variant="outlined"
                  InputLabelProps={{ className: claslbl.clrBlackLblS }}

                />
              )}
            />
          </Grid>
        )}
        <Grid item lg={2} md={2} sm={2} xs={6}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  fullWidth
                  checked={rptParams.chkPrev}
                  onChange={(e) =>
                    onChangeAutoData("chkPrev", e.target.checked)
                  }
                  name="chkPrev"
                />
              }
              size="small"
              color="primary"
              fontSize="small"
              label={t("prev-balance")}
            />
          </FormGroup>
        </Grid>

        {rptParams.type.finalAcc != -1 && (
          <Grid item lg={3} md={4} sm={5} xs={6}>
            <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    fullWidth
                    checked={rptParams.no_stock}
                    onChange={(e) =>
                      onChangeAutoData("no_stock", e.target.checked)
                    }
                    name="no_stock"
                  />
                }
                size="small"
                color="primary"
                fontSize="small"
                label={"استثناء قيمة المخزون(ارباح وخسائر)"}
              />
            </FormGroup>
          </Grid>
        )}
        <Grid item lg={2} md={2} sm={2} xs={6}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  fullWidth
                  checked={rptParams.hide_zero_balance}
                  onChange={(e) =>
                    onChangeAutoData("hide_zero_balance", e.target.checked)
                  }
                  name="no_stock"
                />
              }
              size="small"
              color="primary"
              fontSize="small"
              label={"Hiding zero balances"}
            />
          </FormGroup>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
